var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIconProgressIndicatorShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .bubble-cls-1 {\n        /* fill: #333; */\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bubble-cls-1",
    d: "M40.3,36.9h0c8.4-8.4,8.4-22.1,0-30.5h0c-8.4-8.4-22.1-8.4-30.5,0h0c-8.4,8.4-8.4,22.1,0,30.5h0c3.1,3.1,6.8,5,10.8,5.8h0s3.5,6.7,3.5,6.7c.4.8,1.5.8,2,0l3.5-6.7h0c3.9-.8,7.7-2.8,10.8-5.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIconProgressIndicatorShape);
export default __webpack_public_path__ + "static/media/cloud_icon_progress_indicator_shape.06f92083aa795f3a68bf2f73b08bd8ac.svg";
export { ForwardRef as ReactComponent };